import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import Cache from '@doveconviene/sf-web-js-sdk/cache';
import createFetchCache from '@doveconviene/sf-web-js-sdk/createFetchCache';
import createFetchQueue from '@doveconviene/sf-web-js-sdk/createFetchQueue';
var fetchJson = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return fetch.apply(void 0, _args);
        case 2:
          return _context.abrupt("return", _context.sent.json());
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchJson() {
    return _ref.apply(this, arguments);
  };
}();
var cache = new Cache();
var fetchCache = createFetchCache(fetchJson, cache);
var fetchQueue = createFetchQueue(fetchCache, {
  concurrency: 1
});
export default fetchQueue;